import { DateTime } from 'luxon';

import Timezones from '@/config/Timezones';

export default function useTimezoneHelpers() {
  const formatOffset = (zone) => `(GMT${DateTime.local().setZone(zone).toFormat('ZZ')})`;

  const humanReadableTimezone = (zone) => `${formatOffset(zone)} ${zone}`;

  const getTimezoneOptions = (value) => [
    {
      value,
      text: humanReadableTimezone(value),
    },
    ...Timezones.map(({ label, tzCode }) => ({
      value: tzCode,
      text: `${formatOffset(tzCode)} ${label}`,
    })),
  ];

  return {
    getTimezoneOptions,
    humanReadableTimezone,
  };
}
